import React from "react";
import Hero from "../components/hero";
import LeaderCards from "../components/leader-cards";
import Footer from "../components/footer";

function WhosWho() {
  return (
    <div>
      <Hero />
      <LeaderCards />
      <Footer />
    </div>
  );
}

export default WhosWho;
